import FilterDialog from './Dialog'
import { useSelector } from 'react-redux'
import FilterButton from '../../../../../../../filter/FilterButton'

const FilterButtonContainer = ({ type = 'analyticsUsers' }) => {
  const open = useSelector((state) => state?.filter?.[type]?.open || false)
  return (
    <>
      <FilterButton
        module={type}
        keysFilter={[
          'yearLevelId',
          'yearLevel',
          'rolesId',
          'roles',
          'userIds',
          'subjectId',
          'subject',
          'classId'
        ]}
        keepReload={false}
      />
      {open && <FilterDialog type={type} />}
    </>
  )
}
export default FilterButtonContainer
